export default __webpack_public_path__ + "static/media/8.ecd36c7c.jpg";